<template>
  <base-dialog
    :title="label"
    v-model="visible"
    :show-ok="false"
    :cancel-text="lang == 'CN' ? '关闭' : 'Close'"
  >
    <el-input
      v-model="function_name"
      class="search-input"
      clearable
      @clear="doSearch"
    >
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="doSearch"
      ></el-button>
    </el-input>
    <base-table-lite
      style="height: 500px"
      height="100%"
      ref="table"
      url="view/getDiagExtraData"
      :columns="columns"
      :init-search="false"
      :query="{ packid, version, lang, sub_field, nos, function_name }"
      :show-pagination="false"
    ></base-table-lite>
  </base-dialog>
</template>
<script>
export default {
  name: 'diag-extra-view',
  props: {
    value: Boolean,
    packid: String,
    version: String,
    lang: {
      type: String,
      default: 'EN',
    },
    sub_field: String,
    nos: String,
    label: String,
    searchText: String,
  },
  computed: {
    table() {
      return this.$refs.table
    },
    visible: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      },
    },
  },
  data() {
    return {
      function_name: this.searchText,
      columns: [],
    }
  },
  methods: {
    getDiagField() {
      this.$post('view/getDiagExtraField', {
        packid: this.packid,
        version: this.version,
        lang: this.lang,
        sub_field: this.sub_field,
      })
        .then((resp) => {
          if (resp.data.code == 0) {
            var columns = []
            for (var item of resp.data.data) {
              //这些列不显示
              if (['brand', 'version'].indexOf(item.field) > -1) {
                continue
              }

              var column = {
                bind: {
                  label: item[this.lang.toLowerCase()],
                  prop: item.field,
                },
              }
              if (item.field == 'no') {
                column.bind.width = 80
              }
              columns.push(column)
            }
            this.columns = columns
            this.table.refreshData()
          } else {
            this.$message(resp.data.msg || '获取数据失败')
          }
        })
        .catch((error) => {
          console.error(error)
          this.$message('请求发生错误=>' + error)
        })
    },
    doSearch() {
      this.table.refreshData()
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.function_name = this.searchText
        this.getDiagField()
      }
    },
  },
}
</script>